import React, { HTMLAttributes } from 'react';
import styles from './AppTypography.module.css';

export type AppTextVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'body'
  | 'bodySmall'
  | 'small'
  | 'caption'
  | 'button'
  | 'sectionTitle'
  | 'sectionDescription'
  | 'muted';

export type AppTextWeight = 'regular' | 'medium' | 'semibold' | 'bold';

export type AppTextAlign = 'left' | 'center' | 'right' | 'justify';

type AppTextTag = 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'label';

export interface AppTypographyProps extends Omit<HTMLAttributes<HTMLElement>, 'color'> {
  variant?: AppTextVariant;
  weight?: AppTextWeight;
  align?: AppTextAlign;
  color?: string;
  as?: AppTextTag;
  children: React.ReactNode;
}

const AppTypography: React.FC<AppTypographyProps> = ({
  variant = 'body',
  weight,
  align = 'left',
  color,
  as: Tag = 'span',
  className = '',
  style,
  children,
  ...rest
}) => {
  const classNames = [
    styles.base,
    styles[variant],
    weight ? styles[weight] : '',
    styles[align],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag
      className={classNames}
      style={color ? { ...style, color } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default AppTypography;
